import { Component, Input } from '@angular/core';
import { IGenericModal } from '@interfaces/genericModal.interface';

@Component({
    selector: 'app-generic-modal-with-subtitle',
    templateUrl: './generic-modal-with-subtitle.component.html',
    styleUrls: ['./generic-modal-with-subtitle.component.scss'],
    standalone: false
})
export class GenericModalWithSubtitleComponent {
    @Input() data?: IGenericModal;
}
